import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';


export class MaeConstanciaE {
  c_constancia:Number;
  c_tipo:String;
  x_tipo:String;
  x_titulo:String;
  c_curso: Number;
  x_curso:String;
  c_estado:Number;
  x_prefijo_nro:String;
  x_uid:String;
  f_constancia:String;

  auditoriaBeanM:AuditoriaBeanM;
  serviceCredencialesM:ServiceCredencialesM;
  }


  export class MaeConstanciaM {
    c_constancia:Number;
    c_tipo:String;
    x_tipo:String;
    x_titulo:String;
    c_curso: Number;
    x_curso:String;
    c_estado:Number;
    x_estado:String;
    x_uid:String;
    f_constancia:String;
    }


    export class MaeConstanciaResumenM {
      c_constancia:Number;
      c_tipo:String;
      x_titulo:String;
      c_curso:String;
      x_curso:String;
      n_participantes:Number;
      }


